import __var_0__ from '@stdlib/vendor/events.js';
import __var_1__ from '@stdlib/vendor/debug.js';
import __var_2__ from '@stdlib/utils/define-property';
import __var_3__ from '@stdlib/utils/define-read-only-property';
import __var_4__ from '@stdlib/utils/keys';
import __var_5__ from '@stdlib/utils/copy';
import __var_6__ from '@stdlib/utils/merge';
import __var_7__ from '@stdlib/assert/is-plain-object';
import __var_8__ from './accessors/is_defined.js';
import __var_9__ from './defaults.json';
import __var_10__ from './props/symbol/set.js';
import __var_11__ from './props/symbol/get.js';
import __var_12__ from './props/x/set.js';
import __var_13__ from './props/x/get.js';
import __var_14__ from './props/y/set.js';
import __var_15__ from './props/y/get.js';
import __var_16__ from './props/x-scale/set.js';
import __var_17__ from './props/x-scale/get.js';
import __var_18__ from './props/y-scale/set.js';
import __var_19__ from './props/y-scale/get.js';
import __var_20__ from './props/is-defined/set.js';
import __var_21__ from './props/is-defined/get.js';
import __var_22__ from './props/size/set.js';
import __var_23__ from './props/size/get.js';
import __var_24__ from './props/opacity/set.js';
import __var_25__ from './props/opacity/get.js';
import __var_26__ from './props/color/set.js';
import __var_27__ from './props/color/get.js';
import __var_28__ from './props/label/set.js';
import __var_29__ from './props/label/get.js';
import __var_30__ from './props/auto-render/set.js';
import __var_31__ from './props/auto-render/get.js';
import __var_32__ from './props/x-pos/get.js';
import __var_33__ from './props/y-pos/get.js';
import __var_34__ from './render/index.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// TODO: improve JSDoc examples

// MODULES //
var EventEmitter = __var_0__.EventEmitter;
var logger = __var_1__;
import {scaleLinear as linear} from '@stdlib/vendor/d3-scale.js'; // TODO: remove
var defineProperty = __var_2__;
var setReadOnly = __var_3__;
var objectKeys = __var_4__;
var copy = __var_5__;
var merge = __var_6__;
var isObject = __var_7__;
var isDefined = __var_8__;
var defaults = __var_9__;
var setSymbol = __var_10__;
var getSymbol = __var_11__;
var setX = __var_12__;
var getX = __var_13__;
var setY = __var_14__;
var getY = __var_15__;
var setXScale = __var_16__;
var getXScale = __var_17__;
var setYScale = __var_18__;
var getYScale = __var_19__;
var setIsDefined = __var_20__;
var getIsDefined = __var_21__;
var setSize = __var_22__;
var getSize = __var_23__;
var setOpacity = __var_24__;
var getOpacity = __var_25__;
var setColor = __var_26__;
var getColor = __var_27__;
var setLabel = __var_28__;
var getLabel = __var_29__;
var setAutoRender = __var_30__;
var getAutoRender = __var_31__;
var getXPos = __var_32__;
var getYPos = __var_33__;
var render = __var_34__;


// VARIABLES //

var debug = logger( 'symbols:main' );
var PRIVATE_PROPS = [
	'_autoRender',
	'_color',
	'_isDefined',
	'_label',
	'_opacity',
	'_size',
	'_symbol',
	'_xData',
	'_xScale',
	'_yData',
	'_yScale'
];


// MAIN //

/**
* Symbols constructor.
*
* @constructor
* @param {Options} options - constructor options
* @param {ArrayLike} [options.x=[]] - x-values
* @param {ArrayLike} [options.y=[]] - y-values
* @param {Function} [options.xScale] - x scale function
* @param {Function} [options.yScale] - y scale function
* @param {Function} [options.isDefined] - accessor indicating whether a datum is defined
* @param {string} [options.symbol='closed-circle'] - symbol
* @param {(number|Function)} [options.opacity=0.9] - opacity
* @param {(string|Function)} [options.color] - color
* @param {(string|Function)} [options.label] - label
* @param {(NonNegativeInteger|Function)} [options.size=6] - symbol size
* @param {boolean} [options.autoRender=false] - indicates whether to re-render on a change event
* @throws {TypeError} must provide valid options
* @returns {Symbols} Symbols instance
*
* @example
* var symbols = new Symbols({
*     'x': [0.1,0.2,0.3],
*     'y': [0.4,0.5,0.6]
* });
*/
function Symbols( options ) {
	var self;
	var keys;
	var opts;
	var key;
	var i;
	if ( !( this instanceof Symbols ) ) {
		if ( arguments.length ) {
			return new Symbols( options );
		}
		return new Symbols();
	}
	self = this;

	opts = copy( defaults );
	opts.isDefined = isDefined;
	opts.xScale = linear();
	opts.yScale = linear();

	if ( arguments.length ) {
		if ( !isObject( options ) ) {
			throw new TypeError( 'invalid argument. `options` argument must be an object. Value: `' + options + '`.' );
		}
		opts = merge( opts, options );
	}
	debug( 'Creating an instance with the following configuration: %s.', JSON.stringify( opts ) );
	EventEmitter.call( this );

	for ( i = 0; i < PRIVATE_PROPS.length; i++ ) {
		defineProperty( this, PRIVATE_PROPS[i], {
			'configurable': false,
			'enumerable': false,
			'writable': true,
			'value': null
		});
	}
	// Set options...
	keys = objectKeys( opts );
	for ( i = 0; i < keys.length; i++ ) {
		key = keys[ i ];
		this[ key ] = opts[ key ];
	}

	this.on( 'change', onChange );
	this.on( '_render', onRender );

	return this;

	/**
	* Callback invoked upon receiving a change event.
	*
	* @private
	*/
	function onChange() {
		debug( 'Received a change event.' );
		if ( self._autoRender ) { // eslint-disable-line no-underscore-dangle
			self.render();
		}
	}

	/**
	* Re-emits a render event.
	*
	* @private
	*/
	function onRender() {
		var args;
		var i;
		debug( 'Received a render event. Re-emitting...' );
		args = new Array( arguments.length+1 );
		args[ 0 ] = 'render';
		for ( i = 0; i < arguments.length; i++ ) {
			args[ i+1 ] = arguments[ i ];
		}
		self.emit.apply( self, args );
	}
}

/*
* Create a prototype which inherits from the parent prototype.
*/
Symbols.prototype = Object.create( EventEmitter.prototype );

/*
* Set the constructor.
*/
Symbols.prototype.constructor = Symbols;

/**
* Symbol.
*
* @name symbol
* @memberof Symbols.prototype
* @type {string}
* @throws {TypeError} must be a supported symbol
* @default 'closed-circle'
*
* @example
* var symbols = new Symbols({
*     'symbol': 'open-circle'
* });
*
* var symbol = symbols.symbol;
* // returns 'open-circle'
*/
defineProperty( Symbols.prototype, 'symbol', {
	'configurable': false,
	'enumerable': true,
	'set': setSymbol,
	'get': getSymbol
});

/**
* `x` values.
*
* @name x
* @memberof Symbols.prototype
* @type {ArrayLike}
* @throws {TypeError} must be array-like
* @default []
*
* @example
* var symbols = new Symbols({
*     'x': [0.1,0.2,0.3]
* });
*
* var x = symbols.x;
* // returns [0.1,0.2,0.3]
*/
defineProperty( Symbols.prototype, 'x', {
	'configurable': false,
	'enumerable': true,
	'set': setX,
	'get': getX
});

/**
* `y` values.
*
* @name y
* @memberof Symbols.prototype
* @type {ArrayLike}
* @throws {TypeError} must be array-like
* @default []
*
* @example
* var symbols = new Symbols({
*     'y': [0.4,0.5,0.6]
* });
*
* var y = symbols.y;
* // returns [0.4,0.5,0.6]
*/
defineProperty( Symbols.prototype, 'y', {
	'configurable': false,
	'enumerable': true,
	'set': setY,
	'get': getY
});

/**
* `x` scale function.
*
* @name xScale
* @memberof Symbols.prototype
* @type {Function}
* @throws {TypeError} must be a function
*
* @example
* var symbols = new Symbols({
*     'xScale': function scale(){}
* });
*
* var f = symbols.xScale;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'xScale', {
	'configurable': false,
	'enumerable': true,
	'set': setXScale,
	'get': getXScale
});

/**
* `y` scale function.
*
* @name yScale
* @memberof Symbols.prototype
* @type {Function}
* @throws {TypeError} must be a function
*
* @example
* var symbols = new Symbols({
*     'yScale': function scale(){}
* });
*
* var f = symbols.yScale;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'yScale', {
	'configurable': false,
	'enumerable': true,
	'set': setYScale,
	'get': getYScale
});

/**
* Accessor which defines whether a datum is defined. This accessor is used to define how missing values are encoded. The default behavior is to ignore values which are `NaN`.
*
* @name isDefined
* @memberof Symbols.prototype
* @type {Function}
* @throws {TypeError} must be a function
*
* @example
* var symbols = new Symbols();
* symbols.isDefined = function isDefined( d ) {
*     // Check for `NaN`:
*     return ( d === d );
* }
*
* @example
* function isDefined( d ) {
*     // Check for `NaN`:
*     return ( d === d );
* }
* var symbols = new Symbols({
*     'isDefined': isDefined
* });
* var fcn = symbols.isDefined;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'isDefined', {
	'configurable': false,
	'enumerable': true,
	'set': setIsDefined,
	'get': getIsDefined
});

/**
* Symbol size. When retrieved, the returned value is a size accessor.
*
* @name size
* @memberof Symbols.prototype
* @type {(NonNegativeInteger|Function)}
* @throws {TypeError} must be a nonnegative integer or function
* @default 6
*
* @example
* var symbols = new Symbols({
*     'size': 5
* });
*
* var size = symbols.size;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'size', {
	'configurable': false,
	'enumerable': true,
	'set': setSize,
	'get': getSize
});

/**
* Symbol opacity. When retrieved, the returned value is an opacity accessor.
*
* @name opacity
* @memberof Symbols.prototype
* @type {(number|Function)}
* @throws {TypeError} must be a number or function
* @throws {RangeError} must be a number on the interval `[0,1]`
* @default 0.9
*
* @example
* var symbols = new Symbols({
*     'opacity': 0.5
* });
*
* var opacity = symbols.opacity;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'opacity', {
	'configurable': false,
	'enumerable': true,
	'set': setOpacity,
	'get': getOpacity
});

/**
* Symbols color. When retrieved, the returned value is a color accessor.
*
* @name color
* @memberof Symbols.prototype
* @type {(string|Function)}
* @throws {TypeError} must be a primitive string or function
*
* @example
* var symbols = new Symbols({
*     'color': 'steelblue'
* });
*
* var color = symbols.color;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'color', {
	'configurable': false,
	'enumerable': true,
	'set': setColor,
	'get': getColor
});

/**
* Symbols label. When retrieved, the returned value is a label accessor.
*
* @name label
* @memberof Symbols.prototype
* @type {(string|Function)}
* @throws {TypeError} must be a primitive string or function
*
* @example
* var symbols = new Symbols({
*     'label': 'group-1'
* });
*
* var label = symbols.label;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'label', {
	'configurable': false,
	'enumerable': true,
	'set': setLabel,
	'get': getLabel
});

/**
* Rendering mode. If `true`, an instance re-renders on each change event.
*
* @name autoRender
* @memberof Symbols.prototype
* @type {boolean}
* @throws {TypeError} must be a boolean primitive
* @default false
*
* @example
* var symbols = new Symbols({
*     'autoRender': true
* });
*
* var mode = symbols.autoRender;
* // returns true
*/
defineProperty( Symbols.prototype, 'autoRender', {
	'configurable': false,
	'enumerable': true,
	'set': setAutoRender,
	'get': getAutoRender
});

/**
* Function to map values to x coordinate values.
*
* @name xPos
* @memberof Symbols.prototype
* @type {Function}
*
* @example
* var symbols = new Symbols();
* var xPos = symbols.xPos;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'xPos', {
	'configurable': false,
	'enumerable': true,
	'get': getXPos
});

/**
* Function to map values to y coordinate values.
*
* @name yPos
* @memberof Symbols.prototype
* @type {Function}
*
* @example
* var symbols = new Symbols();
* var yPos = symbols.yPos;
* // returns <Function>
*/
defineProperty( Symbols.prototype, 'yPos', {
	'configurable': false,
	'enumerable': true,
	'get': getYPos
});

/**
* Renders a virtual DOM tree.
*
* @name render
* @memberof Symbols.prototype
* @type {Function}
* @returns {VTree} virtual tree
*
* @example
* var symbols = new Symbols();
*
* var out = symbols.render();
*/
setReadOnly( Symbols.prototype, 'render', render );


// EXPORTS //
export default Symbols;
